/* eslint-disable react/no-children-prop */
/* eslint-disable react/display-name */
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable @typescript-eslint/await-thenable */
/* eslint-disable @typescript-eslint/require-await */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/promise-function-async */
import Joi from '@hapi/joi';
import classNames from 'classnames';
import { Map } from 'immutable';
import React, { ReactNode } from 'react';
import { FormattedNumber } from 'react-intl';
import { connect } from 'react-redux';
import Select from 'react-select';
import Creatable from 'react-select/creatable';
import { ITranslateProps } from '../mixins/translate';
import { useTranslate, translate } from '../mixins/translate/translate';
import { fetchDelete, fetchGet, fetchPost } from '../store/fetch';
import { getFailureModeDisplayName } from '../utils/data/fmecaDataDefinition';
import { AssetTypes } from '../utils/enums/AssetTypes';
import { newLineToBreak } from '../utils/htmlHelper';
import { reactSelectDefaultStyles } from '../utils/reactSelectDefaultStyles';
import { usePatchedDropdownMenu } from '../utils/usePatchedDropdownMenu';
import { LocalizedDatePicker } from './common/LocalizedDatePicker';
import { createMandatoryContext } from './createMandatoryContext';
import { EditPanelSwitch, InputNumber } from './elements';
import { DraggableContainer } from './react-smooth-dnd/DraggableContainer';
import { DraggableItem } from './react-smooth-dnd/DraggableItem';
import { AssetDropzone } from './Surveys/Common/AssetDropzone';
import { AssetTemplate } from './Surveys/Common/AssetTemplate';
import { getAssetOrdersAfterReorder } from './Surveys/Common/getAssetOrdersAfterReorder';
import { NullableFormattedDate } from './utils/NullableFormattedDate';
import { showSavedToast } from './utils/toastMessages';

// Type of props parameter of a function. Used to get the inputs of an Hook
type PropsParameterType<T> = T extends (props: infer TProps) => any ? TProps : never;
// Removes the name property from a type. Used to remove name:string and reintroduce name: StringKeyOf<TBody>
type TypeWithoutNameProperty<T> = Omit<PropsParameterType<T>, 'name'>;
// Keep only properties with type of string
type StringKeyOf<T> = Extract<keyof T, string>;
// Replaces {props: {name:string}} with {props: name: {StringKeyOf<TBody>}}. Used to make sure only properties from TBody can be used for the name property
// Eg <validatingElements.InputText name="remarks" /> is valid, but <validatingElements.InputText name="does not exist"  /> is not
export type ElementPropsWithTypedName<TElement, TBody> = TypeWithoutNameProperty<TElement> & { name: StringKeyOf<TBody> };

type FilterObjectKeys<TObject, TFilterType> = {
    [K in keyof TObject]: TObject[K] extends TFilterType ? K : never;
}[keyof TObject];

// Removes all nullability from property types. Used for easier filtering. In stead of checking for `?string`/`string`/`string|null`/`string|undefined`/etc, it boils down to just `string`
type NonNullableObject<TObject> = {
    [P in keyof TObject]-?: NonNullable<TObject[P]>;
};

// Creates type with only the properties with a certain type TFilterType.
// Used to make sure a property of type string cannot be used in an element intended for a number. This fails: <validatingElements.InputNumber name="remarks"  />
export type FilterPropertiesOnType<TObject, TFilterType> = {
    [P in FilterObjectKeys<NonNullableObject<TObject>, TFilterType>]: NonNullableObject<TObject>[P];
};

export function ValidatingFailureModeDropdown(props: {
    name: string;
    surveyId: string;
    unitId?: string | undefined;
    manifestationId?: string | undefined;
    failureModeId?: string | undefined;
}) {
    const translateKey = useTranslate();
    return (
        <ValidatingFilterDropdownWithUrl
            name={props.name}
            url={`/api/surveys/${props.surveyId}/failureModes`}
            urlQueryParameters={{
                unitId: props.unitId,
                manifestationId: props.manifestationId,
            }}
            getOptionLabel={(failureMode: {
                defaultFailureMode: {
                    name: string;
                };
                customName: string;
                metaData: string;
            }) => getFailureModeDisplayName(failureMode)}
            placeholder={translateKey('common.selectItem', translateKey('failureMode.failureMode'))}
        />
    );
}

function shouldUseFilenameAsDescription(asset: { filename: string }) {
    if (asset.filename.toLowerCase().endsWith('.pdf')) {
        return true;
    }
    if (asset.filename.toLowerCase().endsWith('.xls') || asset.filename.toLowerCase().endsWith('.xlsx')) {
        return true;
    }
    return false;
}

export function ValidatingAssetDropzone(props: {
    objectId?: string | undefined;
    surveyId?: string | undefined;
    equipmentId?: string | undefined;
    name: string;
    acceptedFiles: string;
}) {
    const [filesInProgress, setFilesInProgress] = React.useState(0);

    const currentValidatingFormContext = React.useContext(ValidatingFormContext.context);

    React.useEffect(() => {
        if (filesInProgress === 0) {
            void currentValidatingFormContext.setBusy(false);
        } else {
            void currentValidatingFormContext.setBusy(true);
        }
    }, [filesInProgress]);

    return (
        <div className="row section pt10 mh10 ph20 ">
            <AssetDropzone
                acceptedFiles={props.acceptedFiles}
                onComplete={(file) => {
                    if (file.status === 'success') {
                        void currentValidatingFormContext.onChange(props.name, [
                            ...(currentValidatingFormContext.item[props.name] ?? []),
                            {
                                // eslint-disable-next-line react-hooks/rules-of-hooks
                                assetId: file.s3Id,
                                filename: file.name,
                                mimeType: file.type,
                                description: shouldUseFilenameAsDescription({ filename: file.name }) ? file.name : undefined,
                            },
                        ]);
                    }
                    setFilesInProgress((value) => value - 1);
                }}
                objectId={props.objectId}
                surveyId={props.surveyId}
                equipmentId={props.equipmentId}
                autoProcessQueue={true}
                onAddedFile={() => {
                    setFilesInProgress((value) => value + 1);
                }}
            />
        </div>
    );
}

export function assetToAssetType(asset: { type?: undefined | string; filename?: undefined | string }) {
    if (asset.type) {
        return asset.type;
    }
    if (!asset.filename) {
        return AssetTypes.Image;
    }
    if (asset.filename.toLowerCase().endsWith('.mp4')) {
        return AssetTypes.Video;
    }
    if (asset.filename.toLowerCase().endsWith('.pdf')) {
        return AssetTypes.MeasurementPDF;
    }
    if (asset.filename.toLowerCase().endsWith('.xls') || asset.filename.toLowerCase().endsWith('.xlsx')) {
        return AssetTypes.MeasurementXLS;
    }

    return AssetTypes.Image;
}

export function ValidatingAssetTemplateList(props: {
    objectId?: undefined | string;
    surveyId: string;
    equipmentId?: undefined | string;
    name: string;
    canRemove?: undefined | boolean;
    canEditDescription?: undefined | boolean;
    canSort?: undefined | boolean;
}) {
    return (
        <ValidatingFormContext.Consumer>
            {(state) => (
                <>
                    {!state.item[props.name] || state.item[props.name].length === 0 ? null : (
                        <div className="section row pt10 pr20 pl20 bg-light dark">
                            <DraggableContainer
                                onDrop={(result) => state.onChange(props.name, [...getAssetOrdersAfterReorder(state.item[props.name], result)])}
                                orientation="horizontal"
                                dragHandleSelector=".column-drag-handle"
                            >
                                {state.item[props.name] &&
                                    state.item[props.name].map(
                                        (
                                            asset: { assetId: string; id?: string; description: string; type: string; filename?: string },
                                            i: number,
                                        ) => (
                                            <DraggableItem key={asset.assetId} className="col-sm-6 col-md-3">
                                                <AssetTemplate
                                                    id={asset.assetId ?? asset.id}
                                                    order={i}
                                                    objectId={props.objectId}
                                                    surveyId={props.surveyId}
                                                    type={assetToAssetType(asset)}
                                                    onAssetsChanged={async () => {
                                                        // noop
                                                    }}
                                                    onAssetRemoved={async () => {
                                                        await state.onChange(
                                                            props.name,
                                                            state.item[props.name].filter((b: { assetId: string }) => b.assetId !== asset.assetId),
                                                        );
                                                        await state.addAssetToRemove(asset.assetId, props.surveyId);
                                                    }}
                                                    canRemove={props.canRemove}
                                                    preventAssetDelete
                                                    canEditDescription={props.canEditDescription}
                                                    onAssetTextChange={async (t) => {
                                                        state.item[props.name][i].description = t;
                                                        await state.onChange(props.name, [...state.item[props.name]]);
                                                    }}
                                                    description={asset.description}
                                                    canSort={props.canSort}
                                                    canAddToStartPage
                                                />
                                            </DraggableItem>
                                        ),
                                    )}
                            </DraggableContainer>
                        </div>
                    )}
                </>
            )}
        </ValidatingFormContext.Consumer>
    );
}

export function ValidatingFormInputText(props: IInputTextProps) {
    return <FormInputText {...props} />;
}

class FormInputText extends React.Component<IInputTextProps, Record<string, unknown>> {
    private changed = false;
    public override render() {
        const classValue = classNames({
            field: true,
            'prepend-icon': this.props.icon,
            mt5: this.props.topLabel,
        });

        return (
            <ValidatingFormContext.Consumer>
                {(state) => (
                    <>
                        {this.props.topLabel && <span className="ml5">{this.props.topLabel}</span>}
                        <label htmlFor={this.props.name} className={state.errors.get(this.props.name) ? `state-error ${classValue}` : classValue}>
                            <input
                                autoFocus={this.props.autoFocus}
                                type="text"
                                name={this.props.name}
                                id={this.props.name}
                                className="gui-input"
                                placeholder={this.props.placeholder}
                                value={state.item[this.props.name] || ''}
                                onChange={async (e) => {
                                    this.changed = true;
                                    await state.onChange(this.props.name, e.target.value);
                                }}
                                onBlur={async () => {
                                    if (this.changed) {
                                        await state.onDoValidateOne?.(this.props.name);
                                    }
                                }}
                            />
                            {this.props.icon && (
                                <label htmlFor={this.props.name} className="field-icon">
                                    <i className={this.props.icon}></i>
                                </label>
                            )}
                        </label>
                        <ValidatingFeedback error={state.errors.get(this.props.name)} />
                    </>
                )}
            </ValidatingFormContext.Consumer>
        );
    }
}

interface ITextAreaProps extends IInputTextProps {
    size?: 'xs' | 's' | 'm' | 'l';
}

export function ValidatingFormTextArea(props: ITextAreaProps) {
    return <ValidatingFormTextAreaComponent {...props} />;
}

class ValidatingFormTextAreaComponent extends React.Component<ITextAreaProps, Record<string, unknown>> {
    private changed = false;
    public override render() {
        const classNameValue = this.props.icon ? 'field prepend-icon' : 'field';

        let height: string;
        switch (this.props.size) {
            case 'xs':
                height = '60x';
                break;
            case 's':
                height = '120px';
                break;
            case 'm':
                height = '240px';
                break;
            case 'l':
                height = '360px';
                break;
            default:
                height = '120px';
        }

        return (
            <ValidatingFormContext.Consumer>
                {(state) => (
                    <>
                        {this.props.topLabel && <div className="ml5 mb5">{this.props.topLabel}</div>}
                        <label
                            htmlFor={this.props.name}
                            className={state.errors.get(this.props.name) ? `state-error ${classNameValue}` : classNameValue}
                        >
                            <textarea
                                className="gui-textarea"
                                style={{ height, resize: 'vertical' }}
                                name={this.props.name}
                                id={this.props.name}
                                placeholder={this.props.placeholder}
                                value={state.item[this.props.name] || ''}
                                onChange={async (e) => {
                                    this.changed = true;
                                    await state.onChange(this.props.name, e.target.value);
                                }}
                                onBlur={async () => {
                                    if (this.changed) {
                                        await state.onDoValidateOne?.(this.props.name);

                                        if (this.props.saveOnBlur) {
                                            await state.submit();
                                        }
                                    }
                                }}
                            />
                            {this.props.icon && (
                                <label htmlFor={this.props.name} className="field-icon">
                                    <i className={this.props.icon}></i>
                                </label>
                            )}
                        </label>
                        <ValidatingFeedback error={state.errors.get(this.props.name)} />
                    </>
                )}
            </ValidatingFormContext.Consumer>
        );
    }
}

export class ValidatingFormInputSelect extends React.Component<IInputTextProps, Record<string, unknown>> {
    public override render() {
        const classValue = classNames({
            field: true,
            select: true,
            'prepend-icon': this.props.icon,
            mt5: this.props.topLabel,
        });

        return (
            <ValidatingFormContext.Consumer>
                {(state) => (
                    <>
                        {this.props.topLabel && <span className="ml5">{this.props.topLabel}</span>}
                        <label className={classValue}>
                            <select
                                id={this.props.name}
                                name={this.props.name}
                                value={state.item[this.props.name] || ''}
                                onChange={async (e) => {
                                    await state.onChange(this.props.name, e.target.value);
                                }}
                            >
                                {this.props.placeholder && <option value="">{this.props.placeholder}</option>}
                                {this.props.options &&
                                    this.props.options.map((option, i) => (
                                        <option key={i} value={option.value}>
                                            {option.text}
                                        </option>
                                    ))}
                            </select>
                            <i className="arrow" />
                        </label>
                        <ValidatingFeedback error={state.errors.get(this.props.name)} />
                    </>
                )}
            </ValidatingFormContext.Consumer>
        );
    }
}

interface IInputTextProps {
    placeholder?: string | undefined;
    name: string;
    icon?: string | undefined;
    saveOnBlur?: boolean | undefined;
    topLabel?: string | undefined;
    options?: ISelectOption[] | undefined;
    autoFocus?: boolean | undefined;
}

export interface INumberSelectOption {
    value: number;
    text: string;
}

export function ValidatingFormInputNumberSelect(props: {
    placeholder?: string | undefined;
    name: string;
    icon?: string | undefined;
    saveOnBlur?: boolean | undefined;
    topLabel?: string | undefined;
    options: INumberSelectOption[];
}) {
    return (
        <ValidatingFormInputSelect
            placeholder={props.placeholder}
            name={props.name}
            icon={props.icon}
            saveOnBlur={props.saveOnBlur}
            topLabel={props.topLabel}
            options={props.options.map((i) => ({ text: i.text, value: i.value.toString() }))}
        />
    );
}

interface ISaveButtonProps extends ITranslateProps {
    small?: boolean;
}

class EditPanelSaveButtonComponent extends React.Component<ISaveButtonProps, Record<string, unknown>> {
    public override render() {
        const classValue = classNames({
            btn: true,
            'btn-sm': this.props.small,
            'btn-primary': true,
            ml10: true,
            fs12: this.props.small,
        });

        return (
            <ValidatingFormContext.Consumer>
                {(state) => (
                    <>
                        <input type="submit" disabled={state.isDisabledForLoading} value={this.props.t('common.save')} className={classValue} />
                    </>
                )}
            </ValidatingFormContext.Consumer>
        );
    }
}

export const ValidatingEditPanelSaveButton = translate()(EditPanelSaveButtonComponent);

export function ValidatingFeedback(props: { error?: string | undefined }) {
    const translateKey = useTranslate();
    if (props.error) {
        return <em className="state-error">{translateKey(`validation.${props.error}`)}</em>;
    }
    return null;
}

export interface ISelectOption {
    value: string;
    text: string;
    translateKey?: string;
}

export function ValidatingNumberFilterDropdown(props: {
    name: string;
    placeholder?: string | undefined;
    disabled?: boolean | undefined;
    selectOptions: ISelectOption[];
    notSelectedText?: string | undefined;
    topLabel?: string | undefined;
    dropdownIndicatorStyle?: React.CSSProperties | undefined;
}) {
    let allOptions = props.selectOptions;
    const classValue = classNames({
        field: true,
        mt5: props.topLabel,
    });
    if (props.notSelectedText) {
        allOptions = [{ value: '', text: props.notSelectedText }].concat(allOptions);
    }
    const selectOptions = allOptions.map((option) => ({ value: option.value, label: option.text }));

    return (
        <ValidatingFormContext.Consumer>
            {(state) => (
                <>
                    {props.topLabel && <span className="ml5">{props.topLabel}</span>}
                    <label className={classValue}>
                        <Select
                            isClearable={true}
                            styles={{
                                ...reactSelectDefaultStyles,
                                singleValue: (s) => ({ ...s, ...props.dropdownIndicatorStyle }),
                            }}
                            filterOption={(option, filter) => (option.label ? option.label : '').toLowerCase().indexOf(filter.toLowerCase()) !== -1}
                            placeholder={props.placeholder}
                            name={props.name}
                            isDisabled={props.disabled ?? false}
                            value={state.item[props.name] ? selectOptions.find((i) => i.value === state.item[props.name].toString()) : undefined}
                            options={selectOptions}
                            onChange={async (option: any) => {
                                const value = option ? (option.value ? (option.value === 'null' ? null : parseInt(option.value, 10)) : null) : null;
                                await state.onChange(props.name, value);
                                await state.onDoValidateOne?.(props.name, { [props.name]: value });
                            }}
                        />
                    </label>

                    <ValidatingFeedback error={state.errors.get(props.name)} />
                </>
            )}
        </ValidatingFormContext.Consumer>
    );
}

export function ValidatingFilterDropdown(props: {
    name: string;
    placeholder?: string | undefined;
    disabled?: boolean | undefined;
    selectOptions: ISelectOption[];
    notSelectedText?: string | undefined;
    topLabel?: string | undefined;
    dropdownIndicatorStyle?: React.CSSProperties | undefined;
    readonly?: boolean | undefined;
}) {
    let allOptions = props.selectOptions;
    const classValue = classNames({
        field: true,
        mt5: props.topLabel,
    });
    if (props.notSelectedText) {
        allOptions = [{ value: '', text: props.notSelectedText }].concat(allOptions);
    }
    const selectOptions = allOptions.map((option) => ({ value: option.value, label: option.text }));

    return (
        <ValidatingFormContext.Consumer>
            {(state) => (
                <>
                    {props.topLabel && <span className="ml5">{props.topLabel}</span>}
                    <label className={classValue} data-testid={props.name}>
                        <Select
                            styles={{
                                ...reactSelectDefaultStyles,
                                singleValue: (s: any) => ({ ...s, ...props.dropdownIndicatorStyle }),
                            }}
                            isClearable={true}
                            filterOption={(option, filter) => (option.label ? option.label : '').toLowerCase().indexOf(filter.toLowerCase()) !== -1}
                            placeholder={props.placeholder}
                            name={props.name}
                            isDisabled={props.disabled ?? false}
                            value={state.item[props.name] ? selectOptions.find((i) => i.value === state.item[props.name]) : null}
                            options={selectOptions}
                            onChange={async (option: any) => {
                                const value = option ? (option.value ? (option.value === 'null' ? null : option.value) : null) : null;
                                await state.onChange(props.name, value);
                                await state.onDoValidateOne?.(props.name, { [props.name]: value });
                            }}
                        />
                    </label>

                    <ValidatingFeedback error={state.errors.get(props.name)} />
                </>
            )}
        </ValidatingFormContext.Consumer>
    );
}

export function ValidatingCreatableDropdown(props: {
    name: string;
    placeholder?: string;
    topLabel?: string;
    disabled?: boolean;
    selectOptions: ISelectOption[];
    notSelectedText?: string;
}) {
    let allOptions = props.selectOptions;
    if (props.notSelectedText) {
        allOptions = [{ value: '', text: props.notSelectedText }].concat(allOptions);
    }
    const selectOptions = allOptions.map((option) => ({ value: option.value, label: option.text }));

    return (
        <ValidatingFormContext.Consumer>
            {(state) => {
                let currentValue = state.item[props.name] ? selectOptions.find((i) => i.value === state.item[props.name]) : undefined;
                if (currentValue === undefined && state.item[props.name]) {
                    currentValue = { label: state.item[props.name], value: state.item[props.name] };
                }
                return (
                    <>
                        {props.topLabel && <div className="ml5 pb5">{props.topLabel}</div>}
                        <label className="field">
                            <Creatable
                                isClearable={true}
                                filterOption={(option: any, filter: any) =>
                                    (option.label ? option.label : '').toLowerCase().indexOf(filter.toLowerCase()) !== -1
                                }
                                menuContainerStyle={{ zIndex: 999 }}
                                placeholder={props.placeholder}
                                name={props.name}
                                disabled={props.disabled}
                                value={currentValue}
                                options={selectOptions}
                                onChange={async (option: any) => {
                                    const value = option ? (option.value ? (option.value === 'null' ? null : option.value) : null) : null;
                                    await state.onChange(props.name, value);
                                    await state.onDoValidateOne?.(props.name, { [props.name]: value });
                                }}
                            />
                        </label>

                        <ValidatingFeedback error={state.errors.get(props.name)} />
                    </>
                );
            }}
        </ValidatingFormContext.Consumer>
    );
}

export function ValidatingDropdownToggleCRA<T extends ReactNode>(props: {
    header: string;
    name: string;
    label?: undefined | string;
    caretVisible: boolean;
    directSave?: undefined | boolean;
    postText?: undefined | string;
    options: { value: T; text: string }[];
}) {
    const menuItemsAmount = Number(Boolean(props.header)) + props.options.length;
    const { buttonProps, itemProps, isOpen, setIsOpen } = usePatchedDropdownMenu(menuItemsAmount);
    const classes = classNames('btn-group', { open: isOpen });

    return (
        <ValidatingFormContext.Consumer>
            {(state) => (
                <div>
                    {props.label && (
                        <div className="pv5 ph5">
                            <strong>{props.label}</strong>
                        </div>
                    )}
                    <div className={classes} style={{ whiteSpace: 'nowrap' }}>
                        <button
                            {...buttonProps}
                            className={`btn btn-primary btn-sm fs12 fw500 dropdown-toggle ph10 cra${state.item[props.name]}`}
                            data-toggle="dropdown"
                            type="button"
                        >
                            {state.item[props.name] || '_'}
                            {props.caretVisible && <span className="caret ml10"></span>}
                        </button>
                        <ul className="dropdown-menu pull-right" role="menu">
                            {props.header && (
                                <li
                                    {...itemProps[0]}
                                    onClick={async () => {
                                        setIsOpen(false);
                                        await state.onChange(props.name, null);
                                    }}
                                >
                                    <a className="cursor edit-element" style={{ color: '#000' }}>
                                        <strong>{props.header}</strong>
                                    </a>
                                </li>
                            )}
                            {props.options.map((option, i) => (
                                <li
                                    key={i}
                                    {...itemProps[i + Number(props.header)]}
                                    className={option.value === state.item[props.name] ? 'bg-light darker' : ''}
                                    onClick={async () => {
                                        setIsOpen(false);
                                        await state.onChange(props.name, option.value);
                                        if (props.caretVisible) {
                                            await state.submit();
                                        }
                                    }}
                                >
                                    <a className="cursor edit-element">
                                        {option.value === state.item[props.name] ? (
                                            <strong>
                                                {option.value}:&nbsp;&nbsp;{option.text}
                                            </strong>
                                        ) : (
                                            <>
                                                {option.value}:&nbsp;&nbsp;{option.text}
                                            </>
                                        )}
                                    </a>
                                </li>
                            ))}
                        </ul>
                        {props.postText && <label style={{ margin: '5px 0 0 10px' }}>{props.postText}</label>}
                    </div>
                </div>
            )}
        </ValidatingFormContext.Consumer>
    );
}

export function ValidatingFormEnumValue(props: { name: string; keyToTranslate: string; topLabel?: string }) {
    const translateKey = useTranslate();

    function valueToText(value?: string) {
        if (!value) {
            return null;
        }
        return translateKey(`${props.keyToTranslate}.${value}`);
    }

    return (
        <>
            {props.topLabel && (
                <>
                    <span className="ml5">{props.topLabel}</span>:&nbsp;
                </>
            )}
            <ValidatingFormContext.Consumer>
                {(state) => (
                    <>
                        {Object.prototype.hasOwnProperty.call(state.item, props.name)
                            ? valueToText(state.item[props.name]) || ''
                            : `Unknown name "${props.name}"`}
                    </>
                )}
            </ValidatingFormContext.Consumer>
        </>
    );
}

export function ValidatingFormItemValue(props: { name: string }) {
    return (
        <ValidatingFormContext.Consumer>
            {(state) => (
                <>{Object.prototype.hasOwnProperty.call(state.item, props.name) ? state.item[props.name] || '' : `Unknown name "${props.name}"`}</>
            )}
        </ValidatingFormContext.Consumer>
    );
}

export function ValidatingFormItemValueMultiline(props: { name: string }) {
    return (
        <ValidatingFormContext.Consumer>
            {(state) => (
                <>
                    {newLineToBreak(
                        Object.prototype.hasOwnProperty.call(state.item, props.name) ? state.item[props.name] || '' : `Unknown name "${props.name}"`,
                    )}
                </>
            )}
        </ValidatingFormContext.Consumer>
    );
}

export function ValidatingFormItemIntegerValue(props: { name: string }) {
    return (
        <ValidatingFormContext.Consumer>
            {(state) => (
                <>{Object.prototype.hasOwnProperty.call(state.item, props.name) ? state.item[props.name] || '' : `Unknown name "${props.name}"`}</>
            )}
        </ValidatingFormContext.Consumer>
    );
}

export function ValidatingFormItemNumberValue(props: { name: string }) {
    return (
        <ValidatingFormContext.Consumer>
            {(state) => (
                <>
                    {Object.prototype.hasOwnProperty.call(state.item, props.name) ? (
                        <FormattedNumber value={state.item[props.name]} />
                    ) : (
                        `Unknown name "${props.name}"`
                    )}
                </>
            )}
        </ValidatingFormContext.Consumer>
    );
}

export function ValidatingFormItemDateValue(props: { name: string; topLabel?: string }) {
    return (
        <>
            {props.topLabel && (
                <>
                    <span className="ml5">{props.topLabel}</span> <br />
                </>
            )}
            <ValidatingFormContext.Consumer>
                {(state) => (
                    <>
                        <NullableFormattedDate value={state.getItem(props.name)} />
                    </>
                )}
            </ValidatingFormContext.Consumer>
        </>
    );
}

interface IFormInputNumberProps {
    placeholder?: string;
    name: string;
    topLabel?: string;
    decimalSeparator: string;
}

export function ValidatingFormInputNumber(props: { placeholder?: string; name: string; topLabel?: string }) {
    return <ValidatingCulturedFormInputNumber {...props} />;
}

class FormInputNumber extends React.Component<IFormInputNumberProps, Record<string, unknown>> {
    public override render() {
        const classValue = classNames({
            field: true,
            mt5: this.props.topLabel,
        });

        return (
            <ValidatingFormContext.Consumer>
                {(state) => (
                    <>
                        {this.props.topLabel && <span className="ml5">{this.props.topLabel}</span>}
                        <label htmlFor={this.props.name} className={classValue}>
                            <InputNumber
                                name={this.props.name}
                                className="gui-input"
                                placeholder={this.props.placeholder || ''}
                                value={state.getItem(this.props.name)}
                                decimalSeparator={this.props.decimalSeparator}
                                onChange={async (value) => {
                                    await state.onChange(this.props.name, value);
                                }}
                                onBlur={async (isChanged) => {
                                    if (isChanged) {
                                        await state.onDoValidateOne?.(this.props.name);
                                    }
                                }}
                            />
                        </label>
                        <ValidatingFeedback error={state.errors.get(this.props.name)} />
                    </>
                )}
            </ValidatingFormContext.Consumer>
        );
    }
}

interface IConnectedFormInputNumberReduxProps {
    languageCode: string;
}

interface IConnectedFormInputNumberProps extends IConnectedFormInputNumberReduxProps {
    placeholder?: string;
    name: string;
    topLabel?: string;
}

class ConnectedFormInputNumberComponent extends React.Component<IConnectedFormInputNumberProps, Record<string, unknown>> {
    public static mapStateToProps(this: void, state: any) {
        const { language } = state;
        return {
            languageCode: language.code,
        };
    }

    public override render() {
        return <FormInputNumber decimalSeparator={this.props.languageCode === 'nl' ? ',' : '.'} {...this.props} />;
    }
}

export const ValidatingCulturedFormInputNumber = connect<
    IConnectedFormInputNumberReduxProps,
    IConnectedFormInputNumberProps,
    Record<string, unknown>
>(ConnectedFormInputNumberComponent.mapStateToProps as any, undefined, undefined, {
    forwardRef: true,
})(ConnectedFormInputNumberComponent);

export function ValidatingFormDependentSection<TBody = any>(props: { children: React.ReactNode; showIf: (item: TBody) => boolean }) {
    return (
        <ValidatingFormContext.Consumer>
            {(state) => (
                <>
                    {props.showIf(state.item) ? <>{props.children}</> : undefined}
                    {/* {Object.prototype.hasOwnProperty.call(state.item,props.name) ? <FormattedNumber value={state.item[props.name]} /> : `Unknown name "${props.name}"`} */}
                </>
            )}
        </ValidatingFormContext.Consumer>
    );
}

export function ValidatingFormInputDate(props: { name: string; placeholder?: string; topLabel?: string; className?: string }) {
    const classValue = classNames({
        mt5: props.topLabel,
    });

    return (
        <ValidatingFormContext.Consumer>
            {(state) => (
                <>
                    {props.topLabel && <div className="ml5">{props.topLabel}</div>}
                    <label htmlFor={props.name} className={state.errors.get(props.name) ? `state-error ${classValue}` : classValue}>
                        <LocalizedDatePicker
                            placeholder={props.placeholder as string}
                            value={!state.item[props.name] ? null : new Date(state.item[props.name])}
                            onChange={async (value) => await state.onChange(props.name, value)}
                        />
                    </label>
                    <ValidatingFeedback error={state.errors.get(props.name)} />
                </>
            )}
        </ValidatingFormContext.Consumer>
    );
}

export function ValidatingFormInputDateAsString(props: {
    name: string;
    placeholder?: string | undefined;
    topLabel?: string | undefined;
    className?: string | undefined;
}) {
    return (
        <ValidatingFormContext.Consumer>
            {(state) => (
                <>
                    {props.topLabel && <div className="ml5">{props.topLabel}</div>}
                    <label htmlFor={props.name} className={props.className}>
                        <LocalizedDatePicker
                            placeholder={props.placeholder as string}
                            value={!state.item[props.name] ? null : new Date(state.item[props.name])}
                            onChange={async (value) => await state.onChange(props.name, value?.toISOString())}
                        />
                    </label>
                    <ValidatingFeedback error={state.errors.get(props.name)} />
                </>
            )}
        </ValidatingFormContext.Consumer>
    );
}

export function ValidatingEditPanelSwitch(props: {
    name: string;
    placeholder?: string | undefined;
    topLabel?: string | undefined;
    onText?: string | undefined;
    offText?: string | undefined;
    id?: string | undefined;
}) {
    return (
        <ValidatingFormContext.Consumer>
            {(state) => (
                <EditPanelSwitch
                    name={props.name}
                    id={props.id ? props.id : props.name}
                    placeholder={props.placeholder}
                    topLabel={props.topLabel}
                    value={state.item[props.name]}
                    handleChange={(value) => state.onChange(props.name, value)}
                    onText={props.onText}
                    offText={props.offText}
                />
            )}
        </ValidatingFormContext.Consumer>
    );
}

function CheckboxList(props: { value: string; options: ISelectOption[]; onChange(value: string): void }) {
    const translateKey = useTranslate();
    const selectedValues = props.value.split(',');

    function handleCheckboxChanged(value: string) {
        if (selectedValues.includes(value)) {
            const newSelectedValues = selectedValues.filter((i) => i !== value);
            props.onChange(newSelectedValues.join(','));
        } else {
            const newSelectedValues = [...selectedValues, value];
            props.onChange(newSelectedValues.join(','));
        }
    }

    return (
        <div className="ml10">
            {props.options.map((item) => (
                <React.Fragment key={item.value}>
                    <div className="checkbox-custom mb10">
                        <input
                            type="checkbox"
                            checked={selectedValues.includes(item.value)}
                            onChange={() => handleCheckboxChanged(item.value)}
                            id={item.text}
                        />
                        <label htmlFor={item.text}>{item.translateKey ? translateKey(item.translateKey) : item.text}</label>
                    </div>
                </React.Fragment>
            ))}
        </div>
    );
}

export function ValidatingCheckboxList(props: { name: string; options: ISelectOption[] }) {
    return (
        <ValidatingFormContext.Consumer>
            {(state) => (
                <CheckboxList value={state.item[props.name] || ''} onChange={(value) => state.onChange(props.name, value)} options={props.options} />
            )}
        </ValidatingFormContext.Consumer>
    );
}

interface IFilterDropdownWithUrlProps {
    name: string;
    placeholder?: undefined | string;
    disabled?: undefined | boolean;
    notSelectedText?: undefined | string;
    otherSelectedText?: undefined | string;
    topLabel?: undefined | string;
    url: string;
    urlQueryParameters?: undefined | { [key: string]: string | undefined };

    dataTextField?: undefined | string;
    dataValueField?: undefined | string;
    getOptionLabel?: undefined | ((option: any) => string);
}

interface IFilterDropdownWithUrlState {
    selectOptions: ISelectOption[];
}

export class ValidatingFilterDropdownWithUrl extends React.Component<IFilterDropdownWithUrlProps, IFilterDropdownWithUrlState> {
    constructor(props: IFilterDropdownWithUrlProps) {
        super(props);
        this.state = { selectOptions: [] };
    }

    public override async componentDidUpdate(prevProps: IFilterDropdownWithUrlProps) {
        if (prevProps.url !== this.props.url) {
            await this.componentDidMount();
        }
    }

    public override async componentDidMount() {
        const result = await fetchGet(this.props.url, this.props.urlQueryParameters, [], [403, 404]);
        const dataTextField = this.props.dataTextField || 'name';
        const dataValueField = this.props.dataValueField || 'id';

        let selectOptions = [] as any;
        if (result.json) {
            const items = result.json.items ? result.json.items : result.json;
            selectOptions = items.map((item: { [key: string]: string }) => ({
                value: item[dataValueField],
                text: this.props.getOptionLabel ? this.props.getOptionLabel(item) : item[dataTextField],
            }));
        }
        if (this.props.otherSelectedText) {
            selectOptions.push({
                value: 'null',
                text: this.props.otherSelectedText,
            });
        }

        await this.setState({ selectOptions });
    }

    public override render() {
        return (
            <ValidatingFilterDropdown
                selectOptions={this.state.selectOptions}
                name={this.props.name}
                placeholder={this.props.placeholder}
                disabled={this.props.disabled}
                notSelectedText={this.props.notSelectedText}
                topLabel={this.props.topLabel}
            />
        );
    }
}

type ValidationErrors = Map<string, string | undefined>;

const emptyValidationErrors: ValidationErrors = Map();

async function validate(schema: Joi.Schema, object: any): Promise<{ errors: ValidationErrors; hasErrors: boolean; item?: any }> {
    try {
        if (!schema.validate) {
            console.error('Schema validate is not a function, check schema property');
        }
        const item = await schema.validate(object, { abortEarly: false, stripUnknown: true });
        return { hasErrors: false, errors: emptyValidationErrors, item };
    } catch (error) {
        const map: { [key: string]: string } = {};
        for (const detail of error.details) {
            map[detail.path.join('.')] = detail.type.replace('.', '_');
        }
        return { hasErrors: true, errors: Map(map) };
    }
}

async function updateValidationErrorsForOne(
    schema: Joi.Schema,
    object: any,
    errors: ValidationErrors,
    name: string,
): Promise<{ errors: ValidationErrors; hasErrors: boolean }> {
    const { errors: newErrors, hasErrors } = await validate(schema, object);
    if (newErrors.has(name)) {
        return { errors: errors.set(name, newErrors.get(name)), hasErrors };
    }
    return { errors: errors.remove(name), hasErrors };
}

interface IValidatingFormContextState<ItemType = any> {
    onChange: (key: string, value: any) => void | Promise<void>;
    onDoValidate?: () => void | Promise<void>;
    onDoValidateOne?: (name: string, item?: Partial<ItemType>) => void | Promise<void>;
    item: ItemType;
    getItem: (key: string) => any;
    errors: ValidationErrors;
    submit: () => void | Promise<void>;
    isDisabledForLoading: boolean;
    addAssetToRemove: (assetId: string, surveyId: string) => void | Promise<void>;
    setBusy: (isBusy: boolean) => void | Promise<void>;
}

export const ValidatingFormContext = createMandatoryContext<IValidatingFormContextState>();

interface IValidatingFormProps {
    // eslint-disable-next-line no-shadow
    onChange?: (key: any, value: any, item: any, onChange: (key: any, value: any) => Promise<void>) => Promise<void>;
    onIsItemValidChange?: (isItemValid: boolean) => void;
    schema: Joi.Schema;
    createUrl?: string | undefined;
    createUrlQueryParameters?: { [key: string]: string | undefined } | undefined;
    itemUrl?: string | undefined;
    itemUrlQueryParameters?: { [key: string]: string | undefined } | undefined;
    updateUrl?: string | undefined;
    updateUrlQueryParameters?: { [key: string]: string | undefined } | undefined;
    onSubmitted?: ((id: string) => void) | undefined;
    id?: string | undefined;
    defaultItem?: any | undefined;
    subForm?: boolean | undefined;
    overrideSubmit?: (data: { id?: string | undefined; item: any }) => Promise<{ id: string }>;
    showSavedToast?: boolean | undefined;
    children: React.ReactNode;
}

interface IValidatingFormState {
    values: { [key: string]: string };
    errors: ValidationErrors;
    hasErrors: boolean;
    isSaving: boolean;
    item?: any;
    assetsToRemove: { assetId: string; surveyId: string }[];
    isBusy: boolean;
}

export function ValidatingForm(props: IValidatingFormProps) {
    const translateKey = useTranslate();

    return <ValidatingFormComponent {...props} t={translateKey} />;
}
class ValidatingFormComponent extends React.Component<IValidatingFormProps & { t: (key: string) => string }, IValidatingFormState> {
    constructor(props: IValidatingFormProps & { t: (key: string) => string }) {
        super(props);

        this.state = {
            values: {},
            errors: emptyValidationErrors,
            hasErrors: false,
            isSaving: false,
            assetsToRemove: [],
            isBusy: false,
        };
    }

    public override async componentDidMount() {
        await this.init();
    }
    public override async componentDidUpdate(prevProps: IValidatingFormProps) {
        if (prevProps.id !== this.props.id) {
            await this.init();
        }
    }

    public override render() {
        return (
            <>
                {' '}
                {this.state.item && (
                    <ValidatingFormContext.Provider
                        value={{
                            onChange: (name, value) => this.handleChange(name, value),
                            onDoValidate: () => this.doValidate(),
                            onDoValidateOne: (name) => this.doValidateOne(name),
                            addAssetToRemove: (assetId: string, surveyId: string) =>
                                this.setState({ assetsToRemove: [...this.state.assetsToRemove, { assetId, surveyId }] }),
                            item: this.state.item,
                            errors: this.state.errors,
                            submit: () => this.submit(),
                            isDisabledForLoading: this.state.isSaving || this.state.isBusy,
                            setBusy: (isBusy: boolean) => this.setState({ isBusy }),
                            getItem: (key) => this.getPropertyWithDot(key, this.state.item),
                        }}
                    >
                        <form
                            id="admin-form"
                            className={this.props.subForm ? 'bg-light dark p10' : ''}
                            onSubmit={(e) => {
                                e.preventDefault();
                                void this.submit();
                            }}
                        >
                            {this.props.children}
                        </form>
                    </ValidatingFormContext.Provider>
                )}
            </>
        );
    }

    private async init() {
        if (this.props.id) {
            await this.loadItem();
        } else {
            await this.setState({ item: this.props.defaultItem || {} });
        }
        const { hasErrors } = await validate(this.props.schema, this.state.item);
        await this.setState({ hasErrors });
    }

    private async handleChange(name: string, value: any) {
        await this.setState(({ item }) => ({ item: { ...item, [name]: value } }));
        if (name.includes('.')) {
            const firstKey = name.split('.')[0]!;
            const secondKey = name.split('.')[1]!;
            const { item } = this.state;
            if (!item[firstKey]) {
                item[firstKey] = {};
            }
            item[firstKey] = { ...item[firstKey], [secondKey]: value };
            await this.setState({ item });
        }
        if (this.props.onChange) {
            await this.props.onChange(
                name,
                value,
                this.state.item,
                async (changedKey: any, changedValue: any) => await this.handleChange(changedKey, changedValue),
            );
        }
    }

    private getPropertyWithDot(key: string, item: any) {
        if (!item) {
            return undefined;
        }
        if (key.includes('.')) {
            const firstKey = key.split('.')[0]!;
            const secondKey = key.split('.')[1]!;
            return item[firstKey][secondKey];
        }
        return item[key];
    }

    private async doValidate() {
        const { errors, hasErrors } = await validate(this.props.schema, this.state.item);
        if (this.props.onIsItemValidChange) {
            await this.props.onIsItemValidChange(!hasErrors);
        }
        await this.setState({ errors, hasErrors });
    }

    private async doValidateOne(name: string) {
        const { errors, hasErrors } = await updateValidationErrorsForOne(this.props.schema, this.state.item, this.state.errors, name);
        if (this.props.onIsItemValidChange) {
            await this.props.onIsItemValidChange(!hasErrors);
        }
        await this.setState({ errors, hasErrors });
    }

    private async submit() {
        const { hasErrors, item, errors } = await validate(this.props.schema, this.state.item);
        if (hasErrors) {
            await this.setState({ errors });
            return;
        }
        await this.setState({ hasErrors: false, errors: emptyValidationErrors });
        if (this.state.isBusy || this.state.isSaving) {
            return;
        }

        await this.setState({ isSaving: true });
        let id: string;
        if (this.props.overrideSubmit) {
            // eslint-disable-next-line prefer-destructuring
            id = (await this.props.overrideSubmit({ id: this.props.id, item })).id;
        } else {
            if (this.props.id) {
                if (this.props.updateUrl) {
                    await fetchPost(this.props.updateUrl, this.props.updateUrlQueryParameters, item);
                } else {
                    if (!this.props.itemUrl) {
                        throw new Error('itemUrl cannot be empty');
                    }
                    await fetchPost(this.props.itemUrl, this.props.itemUrlQueryParameters, item);
                }
                // eslint-disable-next-line prefer-destructuring
                id = this.props.id;
            } else {
                if (!this.props.createUrl) {
                    throw new Error('createUrl cannot be empty');
                }
                const result = await fetchPost(this.props.createUrl, this.props.createUrlQueryParameters, item);
                // eslint-disable-next-line prefer-destructuring
                id = result.json.id;
            }
        }
        for (const assetToRemove of this.state.assetsToRemove) {
            await fetchDelete(`/api/surveys/${assetToRemove.surveyId}/assets/${assetToRemove.assetId}`);
        }
        await this.setState({ isSaving: false, assetsToRemove: [] });
        if (this.props.onSubmitted !== undefined) {
            await this.props.onSubmitted(id);
        }
        if (this.props.showSavedToast) {
            void showSavedToast(this.props.t);
        }
    }

    private async loadItem() {
        if (!this.props.itemUrl) {
            throw new Error('itemUrl cannot be empty');
        }
        const result = await fetchGet(this.props.itemUrl, this.props.itemUrlQueryParameters);
        const item = result.json;

        for (const rootKey of Object.keys(item)) {
            if (item[rootKey] && typeof item[rootKey] === 'object') {
                for (const objectKey of Object.keys(item[rootKey])) {
                    item[`${rootKey}.${objectKey}`] = item[rootKey][objectKey];
                }
            }
        }
        await this.setState({ item });
    }
}
